export const relationshipOptions = [
  { value: "bride_friend", label: "Bride's friend", chineseLabel: "新娘朋友" },
  { value: "groom_friend", label: "Groom's friend", chineseLabel: "新郎朋友" },
  { value: "bride_mother_friend", label: "Bride's mother's friend", chineseLabel: "新娘妈妈的朋友" },
  { value: "bride_father_friend", label: "Bride's father's friend", chineseLabel: "新娘爸爸的朋友" },
  { value: "bride_mother_relative", label: "Bride's mother's relative", chineseLabel: "新娘妈妈的亲戚" },
  { value: "bride_father_relative", label: "Bride's father's relative", chineseLabel: "新娘爸爸的亲戚" },
  { value: "groom_mother_friend", label: "Groom's mother's friend", chineseLabel: "新郎妈妈的朋友" },
  { value: "groom_father_friend", label: "Groom's father's friend", chineseLabel: "新郎爸爸的朋友" },
  { value: "groom_mother_relative", label: "Groom's mother's relative", chineseLabel: "新郎妈妈的亲戚" },
  { value: "groom_father_relative", label: "Groom's father's relative", chineseLabel: "新郎爸爸的亲戚" },
];